import { useEffect } from 'react';

export default function useLandingEffects() {
    useEffect(() => {
        document.documentElement.classList.add('js');
    }, []);

    useEffect(() => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const revealEls = [...document.querySelectorAll('.rv')];

        if (reduce || !('IntersectionObserver' in window)) {
            revealEls.forEach((el) => el.classList.remove('pre'));
            return undefined;
        }

        revealEls.forEach((el) => el.classList.add('pre'));

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.remove('pre');
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
        );

        revealEls.forEach((el) => io.observe(el));

        let counted = false;
        const runCounts = () => {
            if (counted) return;
            counted = true;
            document.querySelectorAll('[data-count]').forEach((el) => {
                const end = Number(el.dataset.count);
                const suffix = el.dataset.suffix || '';
                let t0 = null;
                const step = (ts) => {
                    if (!t0) t0 = ts;
                    const p = Math.min((ts - t0) / 1600, 1);
                    const eased = 1 - (1 - p) ** 3;
                    el.textContent = `${Math.round(end * eased).toLocaleString('en-US')}${suffix}`;
                    if (p < 1) requestAnimationFrame(step);
                };
                el.textContent = '0';
                requestAnimationFrame(step);
            });
        };

        const stats = document.querySelector('.stats');
        let statIo;
        if (stats) {
            statIo = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            document.querySelectorAll('[data-count]').forEach((el) => {
                                el.textContent = '0';
                            });
                            runCounts();
                            statIo.disconnect();
                        }
                    });
                },
                { threshold: 0.35 }
            );
            statIo.observe(stats);
        }

        return () => {
            io.disconnect();
            statIo?.disconnect();
        };
    }, []);
}
